<template>
  <nv-tab-page>
    <template slot="toolbar">
      <nv-btn v-if="canEdit()" ref="add-btn" type="add" data-cy="add-sdk" @click="openForm()" />
      <v-spacer />
      <nv-table-search v-model="search" />
    </template>
    <template slot="filters">
      <nv-table-filters :value="tableFilters" @clear="$refs['filter-sheet'].clearFilters()">
        <filter-sheet ref="filter-sheet" @changed="setTableFilters" />
      </nv-table-filters>
    </template>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="table"
      :server-items-length="totalItems"
      :footer-props="footerProps"
      :items-per-page.sync="table.itemsPerPage"
      must-sort
    >
      <template #item.status="{ item }">
        {{ item.status | enumLabel(enumSDKStatuses) }}
      </template>
      <template #item.edit="{ item }">
        <v-btn v-if="canEdit()" ref="edit-btn" icon @click="openForm(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <edit-form v-model="form.show" :editing="form.edit" @saved="addOrUpdateSDK" />
  </nv-tab-page>
</template>

<script>
import HTTP from '@/api/dog';
import { TableMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import EditForm from '@/components/sdk_configurations/BulkEditForm.vue';
import FilterSheet from '@/components/sdk_configurations/FilterSheet.vue';

const headers = [
  { text: 'Name', sortable: false, value: 'name' },
  { text: 'Value', sortable: false, value: 'value' },
  { text: 'Description', sortable: false, value: 'description' },
  { text: 'Status', sortable: false, value: 'status' },
  { align: 'right', sortable: false, value: 'edit' },
];

export default {
  components: { EditForm, FilterSheet },
  mixins: [TableMixin],
  props: {
    isEditable: { type: Boolean, default: true },
  },
  data: () => ({
    headers,
    form: { show: false, edit: null },
    enumSDKStatuses: [],
    tableParam: 'sdk.dt',
  }),
  created() {
    this.enumFetch(HTTP, {
      enumSDKStatuses: '/sdks/configuration/enum/statuses',
    });
  },
  methods: {
    tableFetch() {},
    addOrUpdateSDK(sdk) {
      if (!sdk || !sdk.name) {
        return;
      }
      const index = this.items.findIndex(i => i.name === sdk.name);
      if (index !== -1) {
        this.$set(this.items, index, sdk);
      } else {
        this.items.push(sdk);
      }
      this.totalItems = this.items.length;
      this.$emit('sdk-updated', sdk);
    },
    openForm(item = null) {
      this.form.edit = item;
      this.form.show = true;
    },
    canEdit() {
      return this.isEditable;
    },
    getData() {
      return { sdk_configurations: this.items };
    },
    enumFetch,
  },
};
</script>
